import { RootState } from "core-integration/src/store";
import { getElementStats } from "core-integration/src/store/element-stats/reducers";
import { IElementStat } from "core-integration/src/store/element-stats/types";
import { getElementTypesById } from "core-integration/src/store/element-types/reducers";
import { IElementTypesById } from "core-integration/src/store/element-types/types";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import {
  IElement,
  IElementsById,
  IElementsEventDataById,
} from "core-integration/src/store/elements/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { ITeamsById } from "core-integration/src/store/teams/types";
import * as React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { integerDivide } from "../../utils/points";
import ElementDialogButton from "../ElementDialogButton";
import ElementInTable from "../ElementInTable";
import Table from "../Table";

const ScrollTable = styled.div`
  overflow-x: auto;
  width: 100%;
`;

const StatsTable = styled(Table)`
  white-space: nowrap;
`;

interface IDreamTeamRowProps {
  data: Record<string, any>;
  element: IElement;
  elementTypesById: IElementTypesById;
  renderElementMenu: (index: number) => void;
  stats: ReadonlyArray<IElementStat>;
  teamsById: ITeamsById;
}

const DreamTeamRow: React.FC<IDreamTeamRowProps> = ({
  data,
  element,
  renderElementMenu,
  stats,
}) => (
  <tr>
    <td>
      <ElementDialogButton elementId={element.id} variant="list" />
    </td>
    <td>
      <ElementInTable
        renderElementMenu={() => renderElementMenu(element.id)}
        elementId={element.id}
      />
    </td>
    <td>{integerDivide(data.total_points, 10)}</td>
    {stats.map((s) => (
      <td key={s.name}>{data[s.name]}</td>
    ))}
  </tr>
);

interface IOwnProps {
  dataById: IElementsEventDataById;
  elements: number[];
  renderElementMenu: (index: number) => void;
}

interface IPropsFromState {
  elementsById: IElementsById;
  elementTypesById: IElementTypesById;
  stats: ReadonlyArray<IElementStat>;
  teamsById: ITeamsById;
}

type Props = IOwnProps & IPropsFromState;

const DreamTeamTable: React.FC<Props> = ({
  dataById,
  elements,
  elementsById,
  stats,
  ...rest
}) => {
  return (
    <ScrollTable>
      <StatsTable>
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th>Player</th>
            <th>TP</th>
            {stats.map((s) => (
              <th key={s.name}>
                <abbr title={s.label}>
                  {s.label
                    .split(" ")
                    .map((w) => w[0])
                    .join("")
                    .toUpperCase()}
                </abbr>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {elements.map((e) => (
            <DreamTeamRow
              key={e}
              element={elementsById[e]}
              stats={stats}
              data={dataById ? dataById[e].stats : elementsById[e]}
              {...rest}
            />
          ))}
        </tbody>
      </StatsTable>
    </ScrollTable>
  );
};

const mapStateToProps = (state: RootState): IPropsFromState => {
  return {
    elementsById: getElementsById(state),
    elementTypesById: getElementTypesById(state),
    stats: getElementStats(state),
    teamsById: getTeamsById(state),
  };
};

export default connect(mapStateToProps)(DreamTeamTable);
